import { FC, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Cookies } from '../components/cookies/cookies';
import { Footer } from '../components/footer/footer';
import { Navbar } from '../components/navbar/navbar';
import { RouterPathes } from '../constants/router-paths';

const CHECKOUT_PATHS = new Set([RouterPathes.offerCheckout, RouterPathes.checkoutSuccess]);

export const AppLayout: FC = () => {
  const [showBanner, setShowBanner] = useState(true);
  const location = useLocation();
  const isOfferCheckout = CHECKOUT_PATHS.has(location.pathname as RouterPathes);

  return (
    <main className="bg-background flex min-h-screen w-full flex-col bg-[#1b1f54] bg-center">
      <img
        className={`absolute ${isOfferCheckout ? 'hidden' : ''}`}
        src="/assets/background-gradient.png"
        alt="background-gradient"
      />
      <Navbar />
      <Cookies
        showBanner={showBanner}
        setShowBanner={setShowBanner}
      />
      <main className="flex min-h-[640px] flex-1">
        <Outlet />
      </main>
      <Footer setShowBanner={setShowBanner} />
    </main>
  );
};
